/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { AutocompleteItem } from '@gh/common-shared-data';

export type JobCsInit = { master: AutocompleteItem };

export const isJobEditable = ({ isNotProceeding, isFinalized }: { isNotProceeding: boolean; isFinalized: boolean }) =>
  !(isFinalized || isNotProceeding);
